import React from "react";

type numberedTextProps = {
  data: any;
  withoutNumber?: boolean;
  title?: string;
};
export const NumberedText = ({
  data,
  withoutNumber,
  title
}: numberedTextProps) => {
  return (
    <div className="numberedtext__wrapper">
      {title && title != "" && <h2>{title}</h2>}
      {data.map((data, key) => {
        return (
          <React.Fragment key={key}>
            <p className={withoutNumber ? "nonumber" : "title"}>{data.title}</p>
            {data.subtitle && (
              <p
                className="subtitle"
                dangerouslySetInnerHTML={{ __html: data.subtitle }}
              ></p>
            )}
            {data.content && (
              <div
                className="content"
                dangerouslySetInnerHTML={{
                  __html: `<span>${data.content}</span>`
                  // data.content wrap with html tag to hold html inside, if no html tag when refresh content will disappear
                }}
              ></div>
            )}
          </React.Fragment>
        );
      })}
      <style jsx>{`
        .numberedtext__wrapper {
          counter-reset: terms-counter;
          max-width: 820px;
          margin: 16px;
        }
        h2 {
          color: #404040;
          font-weight: bold;
          font-size: 24px;
          font-weight: bold;
          line-height: 31px;
          text-align: center;
        }
        .title {
          font-weight: bold;
          padding-left: 50px;
          position: relative;
          font-family: 'Roboto-Bold';
        }
        .title::before {
          counter-increment: terms-counter;
          content: counter(terms-counter);
          border-radius: 50%;
          position: absolute;
          left: 0em;
          padding: 2px 8px;
          margin-right: 37px;
          color: var(--color-white);
          text-align: center;
          font-size: 80%;
          background-color: var(--color-red);
        }
        .nonumber {
          font-weight: bold;
          font-family: 'Roboto-Bold';
          padding-left: 0px;
          margin: 0px;
          position: relative;
        }
        .subtitle,
        .content {
          padding-left: ${withoutNumber ? "0px" : "50px"};
          position: relative;
          margin: 0px;
        }
        @media only screen and (max-width: 600px) {
          p,
          .content {
            font-size: 12px;
          }
          h2 {
            font-size: 16px;
            line-height: 20px;
          }
        }
      `}</style>
    </div>
  );
};
